const ON_CHANGE_DEBOUNCE_TIMER = 300;

const PUB_SUB_EVENTS = {
  cartUpdate: 'cart-update',
  quantityUpdate: 'quantity-update',
  variantChange: 'variant-change',
  cartError: 'cart-error'
};

/* JD_TABLET_DRAWER_HIDE_HEADER_CTA_START */
(() => {
  const styleId = 'jd-tablet-drawer-hide-header-cta';
  if (document.getElementById(styleId)) return;

  const style = document.createElement('style');
  style.id = styleId;
  style.textContent = `
    @media screen and (min-width: 750px) and (max-width: 1199px) {
      /*
        Definitive tablet invariant: while the hamburger drawer is open, the
        real storefront logo remains centered but the right-side CTA/control
        column must be completely invisible. The html + active-section state
        intentionally gives this rule higher specificity than the legacy
        tablet-open layout rules in component-menu-drawer.css.
      */
      html.jd-menu-drawer-open .jd-menu-drawer-active .header.header--center-logo > .header__column,
      html.jd-menu-drawer-open .header.header--center-logo:has(> header-drawer > details[open]) > .header__column {
        visibility: hidden !important;
        opacity: 0 !important;
        pointer-events: none !important;
      }

      html.jd-menu-drawer-open .jd-menu-drawer-active .header.header--center-logo > .header__column > .header__icons,
      html.jd-menu-drawer-open .jd-menu-drawer-active .header.header--center-logo .header__cart,
      html.jd-menu-drawer-open .jd-menu-drawer-active .header.header--center-logo .header__cart--page,
      html.jd-menu-drawer-open .jd-menu-drawer-active .header.header--center-logo .header__cta,
      html.jd-menu-drawer-open .jd-menu-drawer-active .header.header--center-logo .header__cta-button,
      html.jd-menu-drawer-open .header.header--center-logo:has(> header-drawer > details[open]) > .header__column > .header__icons,
      html.jd-menu-drawer-open .header.header--center-logo:has(> header-drawer > details[open]) .header__cart,
      html.jd-menu-drawer-open .header.header--center-logo:has(> header-drawer > details[open]) .header__cart--page,
      html.jd-menu-drawer-open .header.header--center-logo:has(> header-drawer > details[open]) .header__cta,
      html.jd-menu-drawer-open .header.header--center-logo:has(> header-drawer > details[open]) .header__cta-button {
        visibility: hidden !important;
        opacity: 0 !important;
        pointer-events: none !important;
      }

      html.jd-menu-drawer-open .jd-menu-drawer-active .header.header--center-logo .header__cta,
      html.jd-menu-drawer-open .jd-menu-drawer-active .header.header--center-logo .header__cta-button,
      html.jd-menu-drawer-open .header.header--center-logo:has(> header-drawer > details[open]) .header__cta,
      html.jd-menu-drawer-open .header.header--center-logo:has(> header-drawer > details[open]) .header__cta-button {
        display: none !important;
      }
    }
  `;
  (document.head || document.documentElement).appendChild(style);
})();
/* JD_TABLET_DRAWER_HIDE_HEADER_CTA_END */

/* JD_DRAWER_SUBMENU_RESET_START */
(() => {
  const boundDrawers = new WeakSet();
  const styleId = 'jd-drawer-submenu-state-guard';

  const installVisualGuard = () => {
    if (document.getElementById(styleId)) return;

    const style = document.createElement('style');
    style.id = styleId;
    style.textContent = `
      @media screen and (max-width: 1199px) {
        #menu-drawer .menu-drawer__menu > li > details[open]:not(.menu-opening) > .menu-drawer__submenu,
        #menu-drawer .menu-drawer__menu > li > details[open]:not(.menu-opening) > .menu-drawer__mega-menu {
          display: none !important;
          visibility: hidden !important;
          opacity: 0 !important;
          pointer-events: none !important;
        }
      }
    `;
    (document.head || document.documentElement).appendChild(style);
  };

  const resetDrawerSubmenus = (headerDrawer) => {
    const rootDetails = headerDrawer?.querySelector(':scope > details');
    if (!rootDetails) return;

    rootDetails.querySelectorAll('details').forEach((details) => {
      details.removeAttribute('open');
      details.classList.remove('menu-opening');
      details
        .querySelector(':scope > summary')
        ?.setAttribute('aria-expanded', 'false');
    });

    rootDetails
      .querySelectorAll(
        '.menu-drawer__main, .menu-drawer__navigation-container, .menu-drawer__inner-submenu, .menu-drawer__submenu',
      )
      .forEach((container) => {
        container.scrollTop = 0;
        container.scrollLeft = 0;
      });
  };

  const bindDrawer = (headerDrawer) => {
    if (!headerDrawer || boundDrawers.has(headerDrawer)) return;

    const rootDetails = headerDrawer.querySelector(':scope > details');
    const rootSummary = rootDetails?.querySelector(':scope > summary');
    if (!rootDetails || !rootSummary) return;

    boundDrawers.add(headerDrawer);

    /*
      Reset synchronously when the root drawer is opened or explicitly closed.
      This prevents a nested <details open> state from surviving the drawer's
      250-400ms closing animation.
    */
    headerDrawer.addEventListener(
      'click',
      (event) => {
        const target = event.target instanceof Element ? event.target : null;
        if (!target) return;

        const clickedSummary = target.closest('summary');
        const clickedCloseButton = target.closest('.header__modal-close-button');
        const clickedNavigationLink = target.closest('#menu-drawer a');

        if (
          clickedSummary === rootSummary ||
          clickedCloseButton ||
          (clickedNavigationLink && !clickedNavigationLink.closest('summary'))
        ) {
          resetDrawerSubmenus(headerDrawer);
        }
      },
      true,
    );

    /* Native root <details> transitions are a second reset boundary. */
    rootDetails.addEventListener('toggle', (event) => {
      if (event.target === rootDetails) {
        resetDrawerSubmenus(headerDrawer);
      }
    });

    /*
      Defensive race guard: if a nested details toggle lands while the drawer
      is already closing, immediately normalize it back to the collapsed state.
    */
    const observer = new MutationObserver((mutations) => {
      const changedOpenState = mutations.some(
        (mutation) => mutation.type === 'attributes' && mutation.attributeName === 'open',
      );

      if (
        changedOpenState &&
        (!rootDetails.hasAttribute('open') || headerDrawer.isClosing)
      ) {
        resetDrawerSubmenus(headerDrawer);
      }
    });

    observer.observe(rootDetails, {
      attributes: true,
      subtree: true,
      attributeFilter: ['open'],
    });

    /* Normalize any stale state present when a Shopify section is re-mounted. */
    if (!rootDetails.hasAttribute('open')) {
      resetDrawerSubmenus(headerDrawer);
    }
  };

  const bindAllDrawers = (scope = document) => {
    installVisualGuard();

    if (scope instanceof Element && scope.matches('header-drawer')) {
      bindDrawer(scope);
    }

    scope.querySelectorAll?.('header-drawer').forEach(bindDrawer);
  };

  if (document.readyState === 'loading') {
    document.addEventListener(
      'DOMContentLoaded',
      () => bindAllDrawers(document),
      { once: true },
    );
  } else {
    bindAllDrawers(document);
  }

  document.addEventListener('shopify:section:load', (event) => {
    bindAllDrawers(event.target || document);
  });
})();
/* JD_DRAWER_SUBMENU_RESET_END */

/* JD_TABLET_FOOTER_SOCIAL_ROW_START */
(() => {
  const styleId = 'jd-tablet-footer-social-row';
  if (document.getElementById(styleId)) return;

  const style = document.createElement('style');
  style.id = styleId;
  style.textContent = `
    @media screen and (min-width: 750px) and (max-width: 1199.98px) {
      .footer .footer__column--social {
        width: 100% !important;
        max-width: 100% !important;
        flex: 0 0 100% !important;
        align-self: stretch !important;
      }

      .footer .footer__list-social.list-social {
        display: flex !important;
        flex-direction: row !important;
        flex-wrap: nowrap !important;
        align-items: center !important;
        justify-content: center !important;
        gap: 1.2rem !important;
        width: 100% !important;
        margin: 0 auto !important;
      }

      .footer .footer__list-social.list-social .list-social__item {
        flex: 0 0 4.4rem !important;
        width: 4.4rem !important;
        height: 4.4rem !important;
      }

      .footer .footer__content-middle-main--3-columns .footer__column--social {
        justify-self: center !important;
      }
    }
  `;
  (document.head || document.documentElement).appendChild(style);
})();
/* JD_TABLET_FOOTER_SOCIAL_ROW_END */
